// extracted by mini-css-extract-plugin
export default {"container":"d3PaNe","item":"pNxnS9","prev":"d9KEJK","current":"fbhMYI","slideToPrev":"Eu0Ma6","slideToNext":"nCjTla"};